import {useEffect, useRef, useState} from 'react';
import '../styles/viewPrescriptionHistory.scss';
import {parseBillHTML} from '../utils/billParser';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {useDispatch, useSelector} from 'react-redux';
import {Link} from 'react-router-dom';
import {CRUDRecordPopup} from '../Redux/Slice/rootSlice';
import {getPatientsBillReportView, getPatientsReportView} from '../Redux/Thunk/Actions';

function ViewPatientReport({loaderchange, popupalert, popuptext}) {
  const sideActive = useSelector(state => state.counter.sidebarnav);
  const activeTab = useSelector(state => state.counter.menuPrescriptionTab);
  console.log(activeTab, 'test');
  const reportViewId = useSelector(state => state.counter.reportViewId);
  let recordpopup = useSelector(state => state.counter.recordpopup);
  const [response, setResponse] = useState();
  const [structuredBillData, setStructuredBillData] = useState(null);

  const fetchReportViewType = useSelector(state => state.counter.reportViewTypeData);
  const [recordCRUDpopup, setRecordCRUDpopup] = useState(recordpopup);
  const dispatch = useDispatch();
  const [reportView_Type, setReportView_Type] = useState('');
  const [printTrigger, setPrintTrigger] = useState(false);

  useEffect(() => {
    const handleThunk = async props => {
      loaderchange(true);
      const payload = reportViewId;

      let patentDetails;
      if (fetchReportViewType === 'Patient Billing') {
        patentDetails = getPatientsBillReportView(payload);
      } else if (fetchReportViewType === 'Patient Reports') {
        patentDetails = getPatientsReportView(payload);
      }
      const response = await dispatch(patentDetails);
      // dispatch(reportViewType(""));
      if (response?.payload?.status?.code === 200) {
        loaderchange(false);
        const billData = response.payload.data;
        if (fetchReportViewType === 'Patient Billing' && billData.report_template && !billData.pharmacy_price) {
          const parsedData = parseBillHTML(billData.report_template);
          setStructuredBillData(parsedData);
        }
        setResponse(billData.report_template);

        // setResponse(response.payload.data.prescription_template);
      } else {
        loaderchange('false');
        popupalert('true');
        popuptext('Network went wrong billing, Please try after some time.');
        popuptext(response?.status?.message);
        setTimeout(() => {
          popupalert('false');
        }, 2000);
      }
    };
    setReportView_Type(fetchReportViewType);
    handleThunk();
    setPrintTrigger(false);
  }, []);

  // function PrintDiv() {
  //   var printHtml = window.open("", "PRINT", "height=800,width=900");

  //   printHtml.document.write("<html><head>");
  //   printHtml.document.write(document.getElementById("demo").innerHTML);
  //   printHtml.document.write("</body></html>");

  //   printHtml.document.close();
  //   printHtml.focus();

  //   printHtml.print();
  //   printHtml.close();

  //   return true;
  // }
  const divRef = useRef(null);
  const Share = async e => {
    console.log('Going', 'pdfpdfpdfpdfpdfpdfpdf');
    try {
      console.log('Going in', 'pdfpdfpdfpdfpdfpdfpdf');
      // Convert the div to canvas
      const canvas = await html2canvas(divRef.current);

      // Convert canvas to PDF
      const pdf = new jsPDF('p', 'mm', 'a4');
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());

      // Convert PDF to Base64 string
      const pdfBase64 = pdf.output('datauristring');
      console.log(pdfBase64, 'pdfpdfpdfpdfpdfpdfpdf');

      // Store the Base64 string in Local Storage
      localStorage.setItem('pdfData', pdfBase64);

      // Provide an option for the user to input a WhatsApp number and handle the sharing process using the WhatsApp API or similar service
      // Example:
      const whatsappNumber = prompt('Enter WhatsApp number');
      if (whatsappNumber) {
        // Use an API to share the PDF via WhatsApp
        // Example: axios.post('/whatsapp/share', { pdfData: pdfBase64, phoneNumber: whatsappNumber });
        // Note: You need to implement a server-side endpoint to handle the WhatsApp sharing process.
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const PrintDiv = () => {
    var new_str = document.getElementById('demo').innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = new_str;
    window.print();
    document.body.innerHTML = originalContents;
    return false;
  };

  var mediaQueryList = window.matchMedia('print');
  mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
      console.log('before print dialog open');
    } else {
      window.location.reload();
      setPrintTrigger(false);
      console.log('after print dialog closed');
    }
  });
  const handleAddRecord = e => {
    dispatch(CRUDRecordPopup(true));
    setRecordCRUDpopup(true);
  };
  const shareMessage = 'Check out this link: https://google.com'; // Message to share
  const phoneNumber = '9182344486'; // WhatsApp number to share with

  const handleShare = () => {
    const apiUrl = `https://api.whatsapp.com/send?phone=${encodeURIComponent(phoneNumber)}&text=${encodeURIComponent(shareMessage)}`;
    window.open(apiUrl, '_blank');
  };

  useEffect(() => {
    console.log(response);
  }, [response]);

  return (
    <>
      <div className={sideActive ? 'patient-view-sa' : 'patient-view'}>
        {/* {recordCRUDpopup && 
      <RecordCRUD
        setclosepopup = {setRecordCRUDpopup}
        loaderchange={loaderchange}
        patientid_share = {patientId}
      />} */}
        <div className='pageWrapper'>
          <div className='content container-fluid'>
            {/* Page Header Start */}
            <div className='page-header'>
              <div className='row'>
                <div className='col'>
                  <h3 className='page-title'>History</h3>
                  <ul className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/' style={{textDecoration: 'none', color: 'black'}}>
                        Dashboard
                      </Link>
                    </li>
                    <li className='breadcrumb-item'>
                      <Link to={fetchReportViewType === 'Patient Billing' ? '/patient_billing' : '/patientreports'} style={{textDecoration: 'none', color: 'black'}}>
                        {fetchReportViewType === 'Patient Billing' ? 'Patient Billing' : 'Patient Reports'}
                      </Link>
                    </li>
                    <li className='breadcrumb-item active'>History</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='buttonHeader'>
                <button
                  className='addPatientRecordbtn'
                  //   onClick={handleAddPrescription}
                  style={{marginRight: '20px'}}
                  onClick={e => {
                    setPrintTrigger(true);
                    PrintDiv();
                  }}>
                  Print
                </button>
                <button
                  className='addPatientRecordbtn'
                  //   onClick={handleAddPrescription}
                  style={{marginRight: '20px'}}
                  onClick={e => {
                    handleShare(e);
                  }}>
                  Share
                </button>
                {/* <button
                  className="addPatientRecordbtn"
                    onClick={(e)=>{
                      handleAddRecord(e)
                    }}
                >
                  Add Record
                </button> */}
              </div>
            </div>
            <div
              // className="profile-menu"
              className='profile-menu '
              id='demo'
              ref={divRef}
              style={{margin: '0 auto', border: 'none'}}
              // id="section-to-print"
            >
              {/* <ul
                className="nav nav-tabs"
                role="tablist"
                style={{ padding: "15px", border: "none" }}
              > */}{' '}
              {/* <button
                  className={`nav-link${
                    // "prescription" === "prescription" ? " active" : ""
                    true ? " active" : ""
                    } about`}
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  name="prescription"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={(e) => {
                    dispatch(menuPrescriptionTab(e.target.name));
                  }}
                  style={{ marginRight: "5px" }}
                >
                  {fetchReportViewType === "Patient Billing"
                    ? "Patient Billing"
                    : "Patient Reports"}
                </button> */}
              {/* <button
                  className={`nav-link${
                    activeTab === "p_records" ? " active" : ""
                  } about`}
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  name="p_records"
                  aria-controls="nav-home"
                  aria-selected="true"
                  onClick={(e) => handleTabClick(e)}
                  style={{ marginRight: "10px" }}
                >
                  Patient records
                </button> */}
              {/* </ul> */}
              {/* activeTab=="prescription"&&<div */}
              <div
                className='report_view_new'
                id='section-to-print'
                style={{
                  // maxWidth: "1150px",
                  maxWidth: '800px',

                  // margin: printTrigger && "0 auto",
                  // border: "1px solid black",
                  // height: "1300px",
                  minWidth: '1150px',
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'flex-start',
                  // padding: "10px",
                  alignContent: 'center',
                  flexDirection: 'column',
                  // margin: "auto 0",
                  // paddingTop: "30px",
                  border: 'none'
                  // marginLeft: "40px",
                  // marginTop: "200px",
                }}
                // style={{ maxWidth: "650px" }}
                dangerouslySetInnerHTML={{
                  __html: response
                }}></div>
              {/* {
                activeTab=="p_records"&&<PatientRecords
                loaderchange={loaderchange}
                patientId={patientId}
                typeshow={"prescription_specific"}
              />
              } */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewPatientReport;
